import { styled } from '@mui/material/styles';

interface FirmDocumentFolderPathLabelRootProps {
  labelVariant: 'singleLine' | 'wrap';
}

export const FirmDocumentFolderPathLabelRoot = styled('span', {
  shouldForwardProp: prop => prop !== 'labelVariant',
})<FirmDocumentFolderPathLabelRootProps>(({ labelVariant, theme }) => ({
  display: labelVariant === 'wrap' ? 'inline' : 'inline-flex',
  maxWidth: '100%',
  minWidth: 0,
  verticalAlign: 'bottom',
  '& span:not([data-firm-document-folder-path-separator="true"])': labelVariant === 'wrap'
    ? {
      overflowWrap: 'anywhere',
      whiteSpace: 'normal',
    }
    : {
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  '& [data-firm-document-folder-path-separator="true"]': {
    color: theme.palette.brand[500],
    flex: labelVariant === 'wrap' ? undefined : '0 0 auto',
    fontWeight: 700,
    padding: theme.spacing(0, 0.5),
    whiteSpace: 'nowrap',
  },
}));
